<template>
    <div class="app">
        <div class="authentication">
            <div class="sign-in">
                <div class="row no-mrg-horizon">
                    <div class="col-md-8 no-pdd-horizon d-none d-md-block">
                        <div class="full-height bg" style="background-image: url('img/cover.jpg')">
                            <div class="img-caption">
                                <h1 class="caption-title">Mesurer, Optimiser, Partager.</h1>
                                <p class="caption-text">Kemtag permet aux gestionaires de parcs de suivre l'utilisation de leurs outils.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 no-pdd-horizon">
                        <div class="full-height bg-white height-100">
                            <div class="vertical-align full-height pdd-horizon-70">
                                <div class="table-cell">
                                    <div class="pdd-horizon-15" v-show="page=='login'">
                                        <h2>Connexion</h2>
                                        <p class="mrg-btm-15 font-size-13">Utilisez votre compte Kemtag</p>
                                        <div id="login_alert" class="alert alert-danger" role="alert" v-if="error">
                                             {{ errormsg }}
                                            <i class="ti-close float-right mt-1" @click="error = false"></i><br>
                                        </div>                                                                                                             
                                        <form @submit.prevent="login">
                                            <div class="form-group">
                                                <label>Adresse e-mail</label>
                                                <div class="input-icon form-group">
                                                    <i class="fa fa-envelope-o"></i>
                                                    <input v-model="email" type="email" class="form-control" placeholder="Saisissez votre adresse email">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>Mot de passe</label>
                                                <div class="input-icon form-group">
                                                    <i class="fa fa-key"></i>
                                                    <input v-model="password" type="password" class="form-control" placeholder="Saisissez votre mot de passe">
                                                </div>
                                            </div>
                                            <button class="btn btn-primary">Connexion</button>
                                        </form>
                                        <hr>
                                            <a href="#"  @click="page='resetPassword'" > Mot de passe oublié ? </a> 
                                            <br>
                                            <a href="#"  @click="page='premiereConnexion'" > Première Connexion ? </a>
                                    </div>
<!-- ######################################################################################################################-->
                                    <div class="pdd-horizon-15" v-show="page=='resetPassword'">
                                        <h2>Réinitialiser</h2>
<!-- ######################################################################################################################-->
                                    <b-alert
                                        :show="alert.dismissCountDown" dismissible 
                                        :variant="sendmail? 'primary' : 'danger'"
                                        @dismissed="[alert.dismissCountDown=0,sendmail = null]"
                                        @dismiss-count-down="countDownChanged">
                                      <div class="text-center m-auto" :class="sendmail? 'text-info' : 'text-danger'">
                                        <span class="lead">
                                          <span v-if="sendmail" > Nous avons envoyé votre lien de {{action}} de mot de passe par e-mail!</span>

                                          <span v-else> {{errormsg}} </span>
                                          </span>

                                        <br><hr>
                                        <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                                      </div>
                                  </b-alert>
<!-- ######################################################################################################################-->
                                        <form @submit.prevent="sendRequestResetPassword(1)">
                                            <div class="form-group">
                                                <label>Adresse e-mail</label>
                                                <div class="input-icon form-group">
                                                    <i class="fa fa-envelope-o"></i>
                                                    <input v-model="email" type="email" class="form-control" placeholder="Saisissez votre adresse email">
                                                </div>
                                            </div>
                                            <b-button variant="primary" disabled v-if="isBusy"> <b-spinner small></b-spinner> Réinitialiser le mot de passe... </b-button>
                                            <b-button type="submit" variant="primary" v-else>Réinitialiser le mot de passe</b-button>
                                        </form>
                                        <hr>
                                            <a href="#" @click="page='login'"> Vous avez déjà un compte </a>
                                            <br>
                                            <a href="#"  @click="page='premiereConnexion'" > Première Connexion ? </a>
                                    </div>
<!-- ######################################################################################################################--> 
                                    <div class="pdd-horizon-15" v-show="page=='premiereConnexion'">
                                        <h2>Première Connexion</h2>
                                       <!-- <div id="login_alert" class="alert" :class="sendmail? 'alert-primary' : 'alert-danger'" role="alert" v-if="sendmail!=null">
                                             <span v-if="sendmail"> Nous avons envoyé votre lien de {{action}} de mot de passe par e-mail! </span> 
                                             <span v-else> {{errormsg}} </span>
                                            <i class="ti-close float-right mt-1" @click="sendmail = null"></i>
                                             <br>
                                             
                                        </div> -->
<!-- ######################################################################################################################-->
                                    <b-alert
                                        :show="alert.dismissCountDown" dismissible 
                                        :variant="sendmail? 'primary' : 'danger'"
                                        @dismissed="[alert.dismissCountDown=0,sendmail = null]"
                                        @dismiss-count-down="countDownChanged">
                                      <div class="text-center m-auto" :class="sendmail? 'text-info' : 'text-danger'">
                                        <span class="lead">
                                          <span v-if="sendmail" > Nous avons envoyé votre lien de création de mot de passe par e-mail!</span>

                                          <span v-else> {{errormsg}} </span>
                                          </span>

                                        <br><hr>
                                        <span>Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes ... </span>
                                      </div>
                                  </b-alert>
<!-- ######################################################################################################################-->
                                        
                                        <form @submit.prevent="sendRequestResetPassword(0)">
                                            <div class="form-group">
                                                <label>Adresse e-mail</label>
                                                <div class="input-icon form-group">
                                                    <i class="fa fa-envelope-o"></i>
                                                    <input v-model="email" type="email" class="form-control" placeholder="Saisissez votre adresse email">
                                                </div>
                                            </div>
                                            <b-button variant="primary" disabled v-if="isBusy"> <b-spinner small></b-spinner>Envoyer... </b-button>
                                            <b-button type="submit" variant="primary" v-else>Envoyer</b-button>
                                        </form>
                                        <hr>
                                            <a href="#" @click="page='login'"> Vous avez déjà un compte </a>
                                            <br>
                                            <a href="#"  @click="page='resetPassword'" > Mot de passe oublié ? </a> 
                                    </div>   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="structure_popup" hide-footer hide-header centered no-close-on-backdrop>
            <Choisir-Structure 
                :structures="structures"
                :email="email"
                :token="input_token"
                @Choisir-Structure-done= "Choisir_Structure_close"
                @Choisir-Structure-Cancel="$refs.structure_popup.hide()">
            </Choisir-Structure>
        </b-modal>
    </div>
</template>

<script>
    import api from "../config/_api";
   // import { mapGetters } from 'vuex';
    import {AUTH_REQUEST,AUTH_REQUEST_TOKEN,AUTH_LOGOUT} from '../store/actions/auth';
    
    import {STRUCTURE_CHANGE} from '../store/actions/user';
    
    import ChoisirStructure from "../components/Choisir_Structure.vue";
    import sha1 from 'sha1';

    export default {
        name: "Login",
        components:{
            'Choisir-Structure': ChoisirStructure},
        data () {
            return {
                structures :  null,
                structure_id : 0,
                role : 0,
                isBusy:false,
                page :"login",
                email: "",
                password: "",
                error: false,
                errormsg: "",
                sendmail: null,
                action : "",
                alert : {
                        dismissSecs: 10,
                        dismissCountDown: 0,
                },
                input_token : "",
            }
        },
        watch:{
            sendmail(newVal,oldVal){
                if (newVal==null & oldVal==true) {
                    this.page="login";
                }
            }
        },
        mounted(){  //responsable de l'affichage du menu de sélection de rôle si les données son présaisie
            this.input_token = this.$route.params.token;
            this.email = this.$route.params.email;
            if((this.input_token!=null) && (this.input_token!="")){
                if((this.email!=null) && (this.email!="")){
                    this.$store.dispatch(AUTH_REQUEST_TOKEN, {api_token: this.input_token, email: this.email}).then(function(res) {
                           
                            this.structures = res.data.structuresDistinct;
                            if(res.data.structuresDistinctsize>1 || this.structures[0].list_roles.length>1){
                                this.$refs.structure_popup.show(); 
                            }
                            else{
                                var role=res.data.structuresDistinct[0].pivot.role_id;
                                if(role==3){
                                    this.toSiteAdherent(this.input_token,this.email,res.data.structuresDistinct[0].id,3);
                                }
                                else{
                                    this.$store.dispatch(STRUCTURE_CHANGE,res.data.structuresDistinct[0]);
                                    window.location.reload();
                                }
                            }
                    }.bind(this)).catch((err) => {
                    //    this.errormsg = err.response.data.error;
                        this.error = true;
                    });
                }
            }
        },
        methods: {
            login () {
                this.$store.dispatch(AUTH_REQUEST, {email: this.email, password: sha1(this.password)}).then((res) => { 
                        this.input_token = res.data.api_token;
                        this.structures = res.data.structuresDistinct ; 
                        if(res.data.structuresDistinctsize>1 || this.structures[0].list_roles.length>1){
                            this.$store.dispatch(AUTH_LOGOUT);
                            this.$refs.structure_popup.show(); 
                        }
                        else{
                            var role=res.data.structuresDistinct[0].pivot.role_id;
                            if((role==3)||(role==4)){
                               this.toSiteAdherent(this.input_token,this.email,res.data.structuresDistinct[0].id,3);
                                }
                                else{
                                    this.$store.dispatch(STRUCTURE_CHANGE,res.data.structuresDistinct[0]);
                                    window.location.reload();
                                }
                        }
                }).catch((err) => {
                    this.errormsg = err.response.data.error;
                    this.error = true;
                });
            },
            sendRequestResetPassword(rqType){
                this.isBusy=true;
                var data = {
                        link : api.link ,
                        email: this.email,
                        type : rqType
                };

                this.axios({url: api.url + 'password/create', data: data, method: 'POST'})
                .then(result => {
                    this.Succes(result.data.type);
                }, error => {
                    this.Echec(error.response.data.error,error.response.data.message);
                });

            },
            Clear(){
                this.password="";
                this.email="";
            },
            Succes(action){
                this.sendmail=true;
                this.showAlert();
                this.action=action;
                this.Clear();
                this.isBusy=false;
            },
            Echec(error,msg){
                this.sendmail=false;
                if (error==1) {
                    this.errormsg=msg; 
                }  
                this.showAlert();
                this.Clear();
                this.isBusy=false;
            },
            
            countDownChanged(dismissCountDown) {
                this.alert.dismissCountDown = dismissCountDown;
            },
            showAlert() {
                this.alert.dismissCountDown = this.alert.dismissSecs;
            },
            toSiteAdherent(token, mail, struct_id, role){
                this.$store.dispatch(AUTH_LOGOUT);
                this.$router.push("/redirect/Adherent/"+token+"/"+mail+"/"+struct_id+"/"+role);
            },
            Choisir_Structure_close(){
              setTimeout(() => {this.$store.dispatch(AUTH_REQUEST, {email: this.email, password: sha1(this.password)}).then((res) => {
                //window.location.reload();
                this.$router.push({path:'/dashboard'});
                this.$refs.structure_popup.hide();
                });}, 1000); //wait for the AUTH_REQUEST to finish
            }
        }
    }
</script>

<style scoped>

</style>